import React from 'react';
import { useField } from 'formik';
import { Box, Typography } from '@mui/material';
import { AntSwitch } from '../../../admin/videos/selectedVideoCardV2/AntSwitchDesign';

interface Props {
  name: string;
  text: string;
}
export default function FieldCheckbox({ name, text }: Props) {
  const [field, , helper] = useField(name);

  return (
    <Box className="flex gap-3 items-center">
      <AntSwitch
        checked={!!field.value}
        onChange={() => helper.setValue(!field.value)}
        $isLarge
      />
      <Typography variant="body1" className="text-text-1">
        {text}
      </Typography>
    </Box>
  );
}
